'use strict';

var novicell = novicell || {};

novicell.siteNavigation = novicell.siteNavigation || new function () {
    this.init = function () {
        var siteNavigationToggle = document.getElementById('js-site-navigation-toggle');
        var siteNavigationList = document.getElementById('js-site-navigation-list');

        if (!siteNavigationToggle || !siteNavigationList) {
            return;
        }

        novicell.subNavigation.init(siteNavigationList);

        siteNavigationToggle.addEventListener('click', function (e) {
            e.preventDefault();

            novicell.helper.toggleClass(siteNavigationToggle, 'site-navigation-burger--active');
            novicell.helper.toggleClass(siteNavigationList, 'site-navigation-list--open');
            novicell.helper.toggleClass(document.body, 'no-scroll');
        });
    };
};
